import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Storage } from "../../storage";
import { createVenueNote, updateVenueNote } from "../../apis/venue-notes";

export function useCreatePublicVenueNote() {
  const queryClient = useQueryClient();

  const { data, error, mutate, status } = useMutation({
    mutationFn: ({
        title,
        noteId,
        businessId,
        note,
        notePriority,
        noteAreaType,
        noteAreaId,
        dateFrom,
        dateTo,
        business_note_heading_suggestions_id,
        placeholder_text,
      }: {
        title: string;
        noteId?: string;
        businessId: string;
        note: string;
        notePriority: string;
        noteAreaType: string;
        noteAreaId: string;
        dateFrom: string;
        dateTo: string;
        business_note_heading_suggestions_id?: string;
        placeholder_text?: string;
      }) => {
        if (noteId) {
          return updateVenueNote({
            noteId,
            businessId,
            title,
            note,
            notePriority,
            noteAreaType,
            noteAreaId,
            dateFrom,
            dateTo,
            business_note_heading_suggestions_id,
            placeholder_text,
            token: Storage.getCurrentUserToken() || "",
          });
        } else {
          return createVenueNote({
            businessId,
            title,
            note,
            notePriority,
            noteAreaType,
            noteAreaId,
            dateFrom,
            dateTo,
            business_note_heading_suggestions_id,
            placeholder_text,
            token: Storage.getCurrentUserToken() || "",
          });
        }
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["loadVenueDetailsBySlug"],
        exact: false,
      });
    },
  });
  return {
    data,
    error,
    mutate,
    status,
  };
}
